import { apolloClient } from '@/services/apollo-client'
import { GET_EMPLOYERS ,GET_EMP_BY_ID} from '@/graphql-toto/EMPLOYER'


export const getEmployersApi = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.query({
                query: GET_EMPLOYERS,
                variables: form
            })
            resolve(res.data.employerList)
        } catch (e) {
            reject(e)
        }
    })
}

export const getEmployerId = (form) => {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await apolloClient.query({
                query: GET_EMP_BY_ID,
                variables: form
            })
            resolve(res.data.getEmpById)
        } catch (e) {
            reject(e)
        }
    })
}